export function getInputValue(elementId: string): string {
    const element = document.getElementById(elementId) as
        | HTMLInputElement
        | HTMLSelectElement
        | null;
    return element ? element.value.trim() : '';
}

/**
 * Selected values from a checkbox multiselect (`.report-multiselect`) or legacy `<select multiple>`.
 */
export function getMultiSelectValues(elementId: string): string[] {
    const root = document.getElementById(elementId);
    if (!root) {
        return [];
    }
    if (root.classList.contains('report-multiselect')) {
        return Array.from(
            root.querySelectorAll<HTMLInputElement>(
                '.report-multiselect__option input[type="checkbox"]:checked'
            ),
            (input) => input.value.trim()
        ).filter((value) => value.length > 0);
    }
    if (root instanceof HTMLSelectElement && root.multiple) {
        return Array.from(root.selectedOptions, (option) => option.value.trim()).filter(
            (value) => value.length > 0
        );
    }
    return [];
}

/**
 * Checked radio value inside a group whose root id is `elementId`
 * (`input[type=radio][name=elementId]`).
 */
export function getRadioGroupValue(elementId: string): string {
    const root = document.getElementById(elementId);
    if (!root) {
        return '';
    }
    const checked = root.querySelector<HTMLInputElement>(
        `input[type="radio"][name="${elementId}"]:checked`
    );
    return checked?.value.trim() ?? '';
}

export function getOptionalNumber(elementId: string): number | undefined {
    const inputValue = getInputValue(elementId);

    if (!inputValue) {
        return undefined;
    }

    const parsed = Number(inputValue);
    return Number.isFinite(parsed) ? parsed : undefined;
}

export function parseCsvValues(rawValue: string): string[] {
    if (!rawValue) {
        return [];
    }

    return rawValue
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value.length > 0);
}

export function setTextContent(elementId: string, value: string): void {
    const element = document.getElementById(elementId);

    if (element) {
        element.textContent = value;
    }
}
